<template>
	<div>
		
		<stato-fase
			:fase-with-stati="faseWithStati"
			:pratica="pratica"
			:pratica-diff="praticaDiff"
			@update-id-stato="pratica.id_stato_fase_5 = $event"
			:disabled="isLoading"
			:action="action"
		></stato-fase>
		
		<v-row>
			<v-col>
				La invitiamo a leggere la pagina ufficiale del MIMIT per visionare le comunicazioni di suo interesse e gli elenchi cronologici cliccando su questo link:<br>
				<a href="https://www.mimit.gov.it/it/normativa/decreti-direttoriali/decreto-direttoriale-5-febbraio-2024-voucher-per-consulenza-in-innovazione-provvedimento-cumulativo-di-concessione-delle-agevolazioni">
					https://www.mimit.gov.it/it/normativa/decreti-direttoriali/decreto-direttoriale-5-febbraio-2024-voucher-per-consulenza-in-innovazione-provvedimento-cumulativo-di-concessione-delle-agevolazioni
				</a>
			</v-col>
		</v-row>
		
		<template v-if="(pratica.id_stato_fase_5 == 38 && isCliente) || isAccountManager || isCoordinatore">
			<v-sheet
				rounded
				color="primary"
				class="my-5 px-4 mt-10 text-h6"
			>
				<span class="tertiary--text">
					Esito da Elenco Cronologico
				</span>
			</v-sheet>
			
			<v-row
				class="flex-column text-h6"
				no-gutters
			>
				<v-col>
					Esito: <span class="primary--text">{{ esitoClickday }}</span>
				</v-col>
				<v-col>
					Tempo: <span class="primary--text">{{ tempoClickday }}</span>
				</v-col>
			</v-row>
		</template>
		
		<v-row
			v-if="pratica.id_stato_fase_5 == 38"
			no-gutters
			class="flex-column mt-2"
		>
			<!--<v-col>-->
			<!--	La invitiamo a leggere la pagina ufficiale dell'INAIL per visionare le comunicazioni di suo interesse e gli elenchi provvisori cliccando su questo link:-->
			<!--</v-col>-->
			<!--<v-col>-->
			<!--	<a-->
			<!--		href="https://www.inail.it/cs/internet/attivita/prevenzione-e-sicurezza/agevolazioni-e-finanziamenti/incentivi-alle-imprese/bando-isi-2022.html?id1=6443200047543#anchor"-->
			<!--		target="_blank"-->
			<!--	>-->
			<!--		https://www.inail.it/cs/internet/attivita/prevenzione-e-sicurezza/agevolazioni-e-finanziamenti/incentivi-alle-imprese/bando-isi-2022.html?id1=6443200047543#anchor-->
			<!--	</a>-->
			<!--</v-col>-->
		</v-row>
		
		<template v-if="isAccountManager && pratica.id_stato_fase_5 == 38">
			<v-sheet
				rounded
				color="primary"
				class="my-5 px-4 mt-10 text-h6"
			>
				<span class="tertiary--text">
					Importo da fatturare in base all'esito
				</span>
			</v-sheet>
			
			<v-row>
				<v-col cols="6">
					<v-badge
						:value="praticaDiff.includes('importo_da_fatturare_esiti_definitivi')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-text-field
							:value="pratica.importo_da_fatturare_esiti_definitivi"
							@input="pratica.importo_da_fatturare_esiti_definitivi = $event !== '' ? $event : null"
							label="Importo da Fatturare"
							outlined
							dense
							hide-details
							:readonly="action == 'show' || !isAccountManager"
							:disabled="isLoading"
							:persistent-placeholder="isCliente"
							type="number"
							min="0"
							:rules="[mixin_rules.min0]"
						></v-text-field>
					</v-badge>
				</v-col>
			</v-row>
		</template>
		
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { eventBus } from "@/event-bus";
export default {
	props: ['value', 'action', 'faseWithStati', 'praticaDiff'],
	data() {
		return {
			pratica: {
				id: null,
				id_stato_fase_5: null,
				ci_sono_aggiornamenti_fase_5: false
			},
			
		}
	},
	
	created() {
		this.isSettingPratica = true;
		// this.pratica = Object.assign({}, this.value);
		this.pratica = this.value;
		this.isSettingPratica = false;
		
		if (this.pratica.ci_sono_aggiornamenti_fase_5 && this.isCliente) {
			this.pratica.ci_sono_aggiornamenti_fase_5 = false;
			this.$emit('input', this.pratica);
			this.$emit('aggiornamenti-visualizzati', {
				praticaId: this.pratica.id,
				aggiornamentoKey: 'ci_sono_aggiornamenti_fase_5',
				aggiornamentoValue: false
			});
			this.salvaAggiornamentiVisualizzati(this.pratica.id, 'ci_sono_aggiornamenti_fase_5');
		}
	},
	
	computed: {
		...mapGetters({
			isAccountManager: 'auth/isAccountManager',
			isCliente: 'auth/isCliente',
			isCoordinatore: 'auth/isCoordinatore'
		}),
		isLoading() {
			return this.isSettingPratica;
		},
		esitoClickday() {
			if (this.pratica.cliccatore_id !== null) {
				return this.pratica.cliccatore.bandi_simulatore[0]?.esito_bando.esito_clickday;
			}
			else return null;
		},
		tempoClickday() {
			if (this.pratica.cliccatore_id !== null) {
				return this.pratica.cliccatore.bandi_simulatore[0]?.esito_bando.tempo_clickday;
			}
			else return null;
		}
	},
	
	watch: {
		pratica: {
			handler(newPratica) {
				if (!this.isLoading) {
					this.$emit('input', newPratica)
				}
			},
			deep: true
		},
		isLoading(newVal) {
			this.$emit('is-loading', newVal)
		},
	},
	
	methods: {
	
	}
	
}
</script>

<style scoped>

</style>